<template>
  <div id="items">

    <PageTitle full :title="$to(category.name)" v-if="category"></PageTitle>

    <Datatable
      v-if="inventory"
      entity="item"
      class="datatable"
      ref="datatable"
      :parameters="{inventory: inventory.id, category: categoryId, company: company}"
      :globalActions="[
        {text: 'items.new', method: onCompanyUserCreate, condition: function() { return $store.getters.loggedUserCanModifyInventory }}]"
      :rowActions="[
        {text: 'datatable.edit', method: onRowEdit},
        {text: 'datatable.delete', method: onRowDelete, condition: function() { return $store.getters.loggedUserCanModifyInventory }},
        {text: 'datatable.clone', method: onRowClone, condition: function() { return $store.getters.loggedUserCanModifyInventory }}]"
      :onRowClick="onRowEdit">
    </Datatable>

    <Modal
      name="delete-confirmation"
      :title="$t('items.confirmation')"
      dismissable
      :actions="[{name: $t('back'), action: 'close'}, {name: $t('datatable.delete'), action: deleteItemAction, primary: true}]">
      <p>{{$t('items.delete_message')}} <b>{{actionRow.name}}</b>?</p>
    </Modal>

    <Modal
        name="clone-confirmation"
        :title="$t('items.confirmation')"
        dismissable
        :actions="[{name: $t('back'), action: 'close'}, {name: $t('datatable.clone'), action: cloneItemAction, primary: true}]">
      <p>{{$t('items.clone_message')}} <b>{{actionRow.name}}</b>?</p>
    </Modal>

  </div>
</template>

<script>

  import Datatable from "@/components/Datatable.vue";
  import {mapActions} from "vuex";
  import PageTitle from "@/components/PageTitle.vue";

  export default {

    name: 'items',

    components: { Datatable, PageTitle },

    data() {
      return {
        actionRow: {},
        categoryId: undefined,
        category: null
      }
    },

    computed: {
      inventory() {
        return this.$store.state.contextInventory
      },
      company() {
        return this.$route.query.company || undefined;
      }
    },

    watch: {
      inventory() {
        if (this.categoryId) {
          this.$router.push(this.$router.buildContext("/categories"));
        }
      }
    },

    async mounted() {
      this.$store.state.pageTitleTranslationKey = "items.title";
      this.$store.state.pageIcon = "/icon/menu.svg";
      this.categoryId = this.$route.query.category;
      if (this.categoryId) {
        let inventory = await this.$store.getters.getContextInventory;
        this.category = await this.getCategory({inventoryId: inventory.id, categoryId: this.categoryId});
      }
    },

    methods: {

      ...mapActions(["deleteItem", "cloneItem", "getCategory"]),

      onRowEdit(row) {
        this.$router.push(this.$router.buildContext("/item/edit", {item: row.id}));
      },
      onRowDelete(row) {
        this.actionRow = row;
        this.$modal.show("delete-confirmation");
      },
      async deleteItemAction() {
        this.$store.commit("showSpinner", true);
        let response = await this.deleteItem({inventoryId: this.inventory.id, itemId: this.actionRow.id});
        this.$modal.show("delete-confirmation", false);
        this.$store.commit("showSpinner", false);
        if (response) {
          this.$refs.datatable.query();
        } else {
          toast(this.$t("error.no_server"),"error");
        }
      },
      onRowClone(row) {
        this.actionRow = row;
        this.$modal.show("clone-confirmation");
      },
      async cloneItemAction() {
        this.$store.commit("showSpinner", true);
        let response = await this.cloneItem({inventoryId: this.inventory.id, itemId: this.actionRow.id});
        this.$modal.show("clone-confirmation", false);
        this.$store.commit("showSpinner", false);
        if (response) {
          this.$router.push(this.$router.buildContext("/item/edit", {item: response.id}));
        } else {
          toast(this.$t("error.no_server"),"error");
        }
      },
      onCompanyUserCreate() {
        this.$router.push(this.$router.buildContext("/item/new"));
      }
    }

  };

</script>
